export const getSearchedProducts = (books, input) =>
	input
		? books.filter(
				({ title, description }) =>
					title.toLowerCase().includes(input.toLowerCase()) ||
					description.toLowerCase().includes(input.toLowerCase())
		  )
		: books;
